import { fetchClientNavigation } from "@src/api";
import { expirationInMs } from "./constants";

export const createFetchClientNavigationWrapper = (
  storeUrl,
  platform,
  variantKey
) => {
  return async (countryCode, keyStoreDataversion, language) => {
    const value = await fetchClientNavigation({
      country: countryCode,
      lang: language,
      storeUrl,
      keyStoreDataversion,
      platform,
      variantKey
    });
    const timeToLiveMs = expirationInMs;
    return { value, timeToLiveMs };
  };
};
